/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { readTarget } from "cms/documents/document/helpers";
import { formatBytes } from "utils/format-bytes";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const DocumentStyleIcon = (props) => {
    
    const { document, options } = props || {};
    const targetData = readTarget(options);
    const { target = "_blank" } = targetData || {};

    return (
        <Fragment>
            {document &&
                <a className='document-display-link'
                    href={document.url}
                    target={target}
                >
                    <div className='document-display'>
                        <div className='document-display-icon'>
                            {/*{getSVGIconForDocument(document)}*/}
                            <DescriptionOutlinedIcon/>
                        </div>
                        <div className='document-display-text'>
                            <div>{document.title}</div>
                        </div>
                        <div className="document-display-size">
                            Size: {formatBytes(document.file_size)}
                        </div>
                    </div>
                    {/*<div className='document-display'>*/}
                    {/*    <div className='document-display-link undecorated'>*/}
                    {/*        <div className='document-display-title'>{document.title}</div>*/}
                    {/*        <div className='document-display-size'>{formatBytes(document.file_size)}</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </a>
            }
        </Fragment>
    );
};

export { DocumentStyleIcon };
